// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  SYSTEM_CHOOSE_CURRENT_COMPANY_POSITION_LIST,
} from './constants';

export function chooseCurrentCompanyPositionList(modal) {
  return {
    type: SYSTEM_CHOOSE_CURRENT_COMPANY_POSITION_LIST,
    data: modal,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEM_CHOOSE_CURRENT_COMPANY_POSITION_LIST:
      return {
        ...state,
        cuCompanyPositionListName:action.data,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/system/redux/chooseCurrentCompanyPositionList.js